import { getUser, getSsoEnabled } from '../utils/globals';
import { useLogin } from './useLogin';
import { useLogout } from './useLogout';
/**
 * # useAuth
 *
 * Usage example:
 *
 * ```javascript
 * import { useAuth } from "@elevio/kb-kit/lib/hooks";
 *
 * const PageWithAuth = () => {
 *   const {
 *     handleClick,
 *     isAgentLoginEnabled,
 *     isSSOEnabled,
 *     userIsLoggedIn,
 *     url,
 *   } = useAuth();
 *
 *   console.log(url); // string
 *   console.log(userIsLoggedIn); // boolean
 *   console.log(isSSOEnabled); // boolean
 *
 *   return (
 *     <div>
 *       <div>userIsLoggedIn: {userIsLoggedIn}</div>
 *       <div>isAgentLoginEnabled: {isAgentLoginEnabled}</div>
 *       <div>isSSOEnabled: {isSSOEnabled}</div>
 *       <button onClick={handleClick}>Login</button>
 *     </div>
 *   );
 * };
 *
 * ```
 */
export function useAuth({ onlyShowLogin, agentLogin, } = {}) {
    const { isAgentLoginEnabled, login, url: loginUrl, } = useLogin({ agentLogin });
    const { logout, url: logoutUrl } = useLogout();
    const user = getUser();
    const userIsLoggedIn = !!user.email;
    const isLogingIn = !userIsLoggedIn || onlyShowLogin;
    let url;
    let handleClick;
    if (isLogingIn) {
        url = loginUrl;
        handleClick = (e) => {
            e.preventDefault();
            login();
        };
    }
    else {
        url = logoutUrl;
        handleClick = (e) => {
            e.preventDefault();
            logout();
        };
    }
    return {
        url,
        userIsLoggedIn,
        handleClick,
        isSSOEnabled: getSsoEnabled(),
        isAgentLoginEnabled,
    };
}
//# sourceMappingURL=useAuth.js.map